module.exports = __webpack_public_path__ + "fonts/fb481cb.woff";